import { useTheme } from '@mui/material';
import { useEffect, useState } from 'react';

/**
 * The progress bar properties
 */
interface ProgressBarProps {
  /**
   * The number to show within the progress bar. This will be converted into a percentage.
   */
  value: number;
}

/**
 * A colored progress bar
 */
const ProgressBar = (props: ProgressBarProps) => {
  const theme = useTheme();
  const valueInPercent = Math.round(props.value * 100);
  const [progressStyle, setProgressStyle] = useState({});

  useEffect(() => {
    if (props.value < 0.33) {
      setProgressStyle({
        backgroundColor: theme.palette.error.main,
      });
    } else if (props.value >= 0.33 && props.value <= 0.66) {
      setProgressStyle({
        backgroundColor: '#ffab00',
      });
    } else {
      setProgressStyle({
        backgroundColor: '#00c853',
      });
    }
  }, [
    props.value,
    theme.palette.error.main,
    theme.palette.success.main,
    theme.palette.warning.main,
  ]);

  return (
    <div
      style={{
        border: `1px solid ${theme.palette.divider}`,
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        height: 26,
        borderRadius: '2em',
      }}
    >
      <div
        style={{
          position: 'absolute',
          lineHeight: '24px',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {`${valueInPercent.toLocaleString()} %`}
      </div>
      <div
        style={{
          height: '100%',
          maxWidth: `${valueInPercent}%`,
          ...progressStyle,
        }}
      />
    </div>
  );
};

export default ProgressBar;
